
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/useful-links",
      function () {
        return require("private-next-pages/dashboard/useful-links.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/useful-links"])
      });
    }
  